<template>
    <LoadingComponent :props="loading" />
    <div id="payment" class="db-tab-div active">
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 mb-5 bg-white border rounded-md p-3">
            <button @click="selectActive(index)"
                class="db-tab-sub-btn w-full flex items-center gap-3 h-10 px-4 rounded-lg transition bg-white hover:text-primary hover:bg-primary/5"
                :data-tab="'#' + paymentGateway.slug" v-for="(paymentGateway, index) in gatewaysData.slice(0, 3)"
                :key="paymentGateway.slug" :class="index === selectIndex ? 'active' : ''">
                <span class="capitalize whitespace-nowrap text-[15px]">
                    {{ paymentGateway.name }}
                </span>
            </button>

            <div v-if="gatewaysData.length > 3" class="dropdown-group w-full">
                <button
                    class="dropdown-btn w-full flex items-center gap-3 h-10 px-4 rounded-lg transition bg-white hover:text-primary hover:bg-primary/5">
                    <i class="fa-solid fa-circle-chevron-down text-sm"></i>
                    <span class="capitalize whitespace-nowrap text-[15px]"> {{ $t('label.more_gateway') }}</span>
                </button>
                <div class="w-full dropdown-list absolute top-[42px] right-0 z-30 p-2 rounded-md bg-white shadow-lg">
                    <button @click="selectActive(index + 3)"
                        class="w-full flex items-center h-8 px-2 rounded-lg transition bg-white hover:text-primary hover:bg-primary/5"
                        :data-tab="'#' + paymentGateway.slug"
                        v-for="(paymentGateway, index) in gatewaysData.slice(3, gatewaysData.length)"
                        :key="paymentGateway.slug" :class="index + 3 === selectIndex ? 'active' : ''">
                        {{ paymentGateway.name }}
                    </button>
                </div>
            </div>
        </div>
        <div :id="paymentGateway.slug" class="db-card db-tab-sub-div" v-for="(paymentGateway, index) in gatewaysData"
            :key="paymentGateway.slug" :class="{ 'active': index === selectIndex, 'on-update': onUpdateActive && index === selectIndex }">
            <div class="db-card-header items-center justify-between gap-4">
                <h3 class="db-card-title">{{ paymentGateway.name }}</h3>
            
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
            <div class="db-card-body">
                <form @submit.prevent="save(paymentGateway.slug)" :id="'formElem-' + paymentGateway.slug" class="w-full d-block">
                    <div class="form-row">
                        <input type="hidden" :value="paymentGateway.slug" name="payment_type">

                        <template v-for="paymentGatewayOption in paymentGateway.options" :key="paymentGatewayOption.option">
                            <div v-if="isOptionVisible(paymentGateway, paymentGatewayOption.option)" class="form-col-12" :class="!isTransferDetailsOption(paymentGatewayOption.option) ? 'sm:form-col-6' : ''">

                                <label :for="paymentGatewayOption.option" class="db-field-title">
                                    {{ $t("label." + paymentGatewayOption.option) }}
                                </label>

                                <!-- Special case: transferencia_payment_details -> render 5 separate fields -->
                                <template v-if="isTransferDetailsOption(paymentGatewayOption.option)">
                                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                        <input type="text" :value="extractTransferValue(paymentGatewayOption.value, 'Banco')"
                                            v-bind:class="errors['transferencia_banco'] ? 'invalid' : ''"
                                            name="transferencia_banco" id="transferencia_banco" placeholder="Banco"
                                            class="db-field-control" />

                                        <input type="text" :value="extractTransferValue(paymentGatewayOption.value, 'Titular')"
                                            v-bind:class="errors['transferencia_titular'] ? 'invalid' : ''"
                                            name="transferencia_titular" id="transferencia_titular" placeholder="Titular"
                                            class="db-field-control" />

                                        <input type="text" :value="extractTransferValue(paymentGatewayOption.value, 'Cuenta')"
                                            v-bind:class="errors['transferencia_cuenta'] ? 'invalid' : ''"
                                            name="transferencia_cuenta" id="transferencia_cuenta" placeholder="Cuenta"
                                            class="db-field-control" />

                                        <input type="text" :value="extractTransferValue(paymentGatewayOption.value, 'CLABE')"
                                            v-bind:class="errors['transferencia_clabe'] ? 'invalid' : ''"
                                            name="transferencia_clabe" id="transferencia_clabe" placeholder="CLABE"
                                            class="db-field-control" />

                                        <input type="text" :value="extractTransferValue(paymentGatewayOption.value, 'Referencia')"
                                            v-bind:class="errors['transferencia_referencia'] ? 'invalid' : ''"
                                            name="transferencia_referencia" id="transferencia_referencia" placeholder="Referencia"
                                            class="db-field-control" />
                                    </div>
                                </template>

                                <input v-else-if="paymentGatewayOption.type === enums.inputTypeEnum.TEXT" type="text"
                                    v-model="paymentGatewayOption.value"
                                    v-bind:class="errors[paymentGatewayOption.option] ? 'invalid' : ''"
                                    :name="paymentGatewayOption.option" :id="paymentGatewayOption.option"
                                    class="db-field-control" />

                                <template v-else>
                                    <vue-select
                                        :key="paymentGatewayOption.option"
                                        class="db-field-control f-b-custom-select"
                                        v-model="paymentGatewayOption.value"
                                        :options="getSelectOptions(paymentGatewayOption)"
                                        label-by="name"
                                        value-by="id"
                                        :closeOnSelect="true"
                                        :searchable="true"
                                        :clearOnClose="true"
                                    />
                                    <input type="hidden" :name="paymentGatewayOption.option" :value="paymentGatewayOption.value" />
                                </template>

                                <small class="db-field-alert" v-if="errors[paymentGatewayOption.option]">{{
                                    errors[paymentGatewayOption.option][0]
                                }}</small>

                            </div>
                        </template>

                        <div v-if="paymentGateway.slug === 'cashondelivery' || paymentGateway.slug === 'credit'">
                            <span v-if="paymentGateway.slug === 'cashondelivery'" class="text-sm font-normal">{{ $t("label.cashondelivery_text") }}</span>
                            <span v-if="paymentGateway.slug === 'credit'" class="text-sm font-normal">{{ $t("label.credit_text") }}</span>
                        </div>
                        
                        <div v-else class="form-col-12 border-t pt-5 mt-3">
                            <button type="submit" :id="'formButton-' + paymentGateway.slug" class="db-btn text-white bg-primary" :disabled="isSaving">
                                <template v-if="isSaving">
                                    <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                        <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                    </svg>
                                    <span>{{ $t('button.updating') }}</span>
                                </template>
                                <template v-else>
                                    <i class="lab lab-fill-save"></i>
                                    <span>{{ $t("button.save") }}</span>
                                </template>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import appService from "../../../../services/appService";
import alertService from "../../../../services/alertService";
import inputTypeEnum from "../../../../enums/modules/inputTypeEnum";

export default {
    name: "PaymentGatewayComponent",
    components: { LoadingComponent },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            search: {
                paginate: 0,
                order_column: "id",
                order_type: "asc",
            },
            selectIndex: 0,
            enums: {
                inputTypeEnum: inputTypeEnum
            },
            isSaving: false,
            onUpdateActive: false,
            errors: {},
            gatewaysData: []
        };
    },
    computed: {
        paymentGateways: function () {
            return this.$store.getters["paymentGateway/lists"];
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            return this.$store
                .dispatch("paymentGateway/lists", this.search)
                .then((res) => {
                    const rawData = JSON.parse(JSON.stringify(this.paymentGateways));
                    if (Array.isArray(rawData)) {
                        rawData.forEach(gateway => {
                            if (Array.isArray(gateway.options)) {
                                gateway.options.forEach(opt => {
                                    if (opt.activities) {
                                        let activitiesObj = typeof opt.activities === 'string' ? JSON.parse(opt.activities) : opt.activities;
                                        const keys = Object.keys(activitiesObj);
                                        const hasNumericKeys = keys.every(k => !isNaN(k) && k.trim() !== '');
                                        if (opt.value !== null && opt.value !== undefined) {
                                            if (hasNumericKeys) {
                                                opt.value = Number(opt.value);
                                            } else {
                                                opt.value = String(opt.value);
                                            }
                                        }
                                    }
                                });
                                gateway.options.sort((a, b) => {
                                    const getScore = (optName) => {
                                        if (optName.endsWith('_status')) return 100;
                                        if (optName.endsWith('_mode')) return 50;
                                        return 0;
                                    };
                                    return getScore(a.option) - getScore(b.option);
                                });
                            }
                        });
                    }
                    this.gatewaysData = rawData;
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                })
                .catch((err) => {
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch(() => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        isTransferDetailsOption: function (option) {
            return option === 'transferencia_payment_details';
        },
        extractTransferValue: function (rawValue, label) {
            const lines = String(rawValue || '').split('\n');
            const line = lines.find((item) => item.trim().toLowerCase().startsWith((label + ':').toLowerCase())) || '';
            return line.replace(new RegExp('^' + label + '\s*:\s*', 'i'), '').trim();
        },
        isOptionVisible: function (paymentGateway, optionName) {
            if (paymentGateway.slug === 'stripe') {
                const modeOpt = paymentGateway.options.find(o => o.option === 'stripe_mode');
                const mode = modeOpt ? Number(modeOpt.value) : 5; // Default sandbox
                if (optionName === 'stripe_key' || optionName === 'stripe_secret') {
                    return mode === 10; // LIVE
                }
                if (optionName === 'stripe_sandbox_key' || optionName === 'stripe_sandbox_secret') {
                    return mode === 5; // SANDBOX
                }
            }
            if (paymentGateway.slug === 'paypal') {
                const modeOpt = paymentGateway.options.find(o => o.option === 'paypal_mode');
                const mode = modeOpt ? Number(modeOpt.value) : 5; // Default sandbox
                if (optionName === 'paypal_client_id' || optionName === 'paypal_client_secret') {
                    return mode === 10; // LIVE
                }
                if (optionName === 'paypal_sandbox_client_id' || optionName === 'paypal_sandbox_client_secret') {
                    return mode === 5; // SANDBOX
                }
            }
            return true;
        },
        getSelectOptions: function (option) {
            if (!option.activities) return [];
            let activitiesObj = typeof option.activities === 'string' ? JSON.parse(option.activities) : option.activities;
            return Object.entries(activitiesObj).map(([key, value]) => {
                const isNumeric = !isNaN(key) && key.trim() !== '';
                return {
                    id: isNumeric ? Number(key) : key,
                    name: this.$t("label." + value)
                };
            });
        },
        save: function (slug) {
            try {
                this.isSaving = true;
                this.onUpdateActive = true;
                let form = document.getElementById("formElem-" + slug);
                let formDataObj = {};
                if (!form) {
                    alertService.error(this.$t('message.invalid_form'));
                    this.isSaving = false;
                    this.onUpdateActive = false;
                    return;
                }
                [...form.elements].filter((el) => el.tagName !== 'BUTTON').forEach((item) => {
                    if (item.name) {
                        formDataObj[item.name] = item.value;
                    }
                });

                this.$store.dispatch("paymentGateway/save", { form: formDataObj, search: this.search }).then((res) => {
                    alertService.successFlip(res.config.method === "put" ?? 0, this.$t("menu.payment_gateway"));
                    this.fetchData(false);
                    this.errors = {};
                    this.isSaving = false;
                    this.onUpdateActive = false;
                }).catch((err) => {
                    this.errors = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {};
                    if (err.response && err.response.data && err.response.data.message) {
                        alertService.error(err.response.data.message);
                    }
                    this.isSaving = false;
                    this.onUpdateActive = false;
                });
            } catch (err) {
                this.isSaving = false;
                this.onUpdateActive = false;
                alertService.error(err);
            }
        },
        selectActive: function (index) {
            this.selectIndex = index;
        }
    }
};
</script>